import { render, staticRenderFns } from "./SaveBtn.vue?vue&type=template&id=60dbf03d"
import script from "./SaveBtn.vue?vue&type=script&lang=js"
export * from "./SaveBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports